// Custom cinematic HomeRange imagery (AI-generated, brand-owned).
const B = "https://static.prod-images.emergentagent.com/jobs/98d31929-0a65-48ad-9c33-4d117fb8b00d/images/";

export const MEDIA = {
  homeHero: `${B}240f67ff6a117c84bf99f45b1a42aa29a0e631d455da547811b8cab5e1b422de.jpeg`,
  exploreAI: `${B}c25e4f97bc71075b08d10722e5d2337c6da4463fdb22daf8c782598b419936f2.jpeg`,
  exploreGear: `${B}403282a18ddd484c64d11d974580a86164f23ad854e2639874bc3bdf3654e305.jpeg`,
  exploreOutfitters: `${B}8e9f2b57f6d308d27cc814e9a853798328ae9026ba7f17e088f0dd9e9a2e7ec0.jpeg`,
  exploreRegs: `${B}657c6eebf47c06a7ecc848d4244b5bc465526c814e40cf7bf01ae06dbd434afd.jpeg`,
  exploreField: `${B}ffd8fbabf37df6d27625c78281c8c27891655d10dfeff67cdd0c343e52a84d16.jpeg`,
  exploreRecipes: `${B}2015abecd16472c0798165f91896fda1ccb59994a046acfadd37c961ee4ca857.jpeg`,
  stateHero: `${B}c81f24ff97726b866b791896b2e9ece2b2e7fbb5fb7eb9d90965c5107442b838.jpeg`,
  gearHero: `${B}b933d93935043684e0132381d7dd704db2f7b94477d46d06245f67c43e7977c7.jpeg`,
  firearmsBand: `${B}a7c50bf1718093f97816c2eaa71136cad936f42f48237992e84a0723ce1ac12f.jpeg`,
  gear: {
    optics: `${B}979134253f7e6799d6277cf9968683ae238e9c07e28b41f3f7c18f0176740d52.jpeg`,
    archery: `${B}d6450f9404910e4889763c5ade13ab900fd6d7391d96eb8e9e449fbc25477c54.jpeg`,
    packs: `${B}7a1f5ca08abc918ba904d7c0bdad31c86ca39189ba27f922b91014760e0ab593.jpeg`,
    apparel: `${B}5ace98ab7571429aeceb7da6e5541254b4d0b2690f581e0ffb76c5f941720bd7.jpeg`,
    boots: `${B}80d9f33f3506d43daadfd9422401cfc0588a45ed5c5d6c9f095ae6461112dd75.jpeg`,
    accessories: `${B}23d026afa7016c7ca8b1a608c2c96ce7245532287816da5fc3dbf3e0a6bdb123.jpeg`,
  },
  fieldnotesHero: `${B}1fcbd8c727c8dbd2cbc1d147841c371f9b8a257f930c83dae81063864a61d8cd.jpeg`,
  fieldnotesMyNotes: `${B}c3456ce68537e73f1c3c661784c9b7a6759ddfa5a209ffd53eb770f98a357a92.jpeg`,
  archiveHero: "https://images.unsplash.com/photo-1567463330419-d65c673554c2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400&fit=crop",
};
